/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {SecondaryText} from "components/Text";
import {colors} from "nxtconstants";
import Spinner from "components/Spinner";

const EditFaq = ({
  loading,
  handleEditFaq,
  question,
  setQuestion,
  answer,
  setAnswer
}) => {
  return (
    <AddFaqWrapper>
      <SecondaryText>
        Edit Faq
      </SecondaryText>
      {
        !loading ? (
          <FormWrapper>
            <input
              name="question"
              placeholder="Faq Title"
              type="text"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
            <textarea
              name="answer"
              placeholder="Faq Description"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
            />
            <button type="button" onClick={handleEditFaq}>
              Update
            </button>
          </FormWrapper>
        ) : (
          <Loader>
            <Spinner />
          </Loader>
        )
      }
    </AddFaqWrapper>
  );
};

const AddFaqWrapper = styled.div`
  padding: 0 2rem 2rem;
`;

const FormWrapper = styled.div`
  text-align: right;

  input, textarea {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
    resize: none;
    padding: 0.5rem;
    font-size: 1.1rem;
    border: 1px solid #cccccc;

    &::placeholder {
      color: #aaaaaa; 
    }
  }

  textarea {
    height: 150px;
  }

  button {
    background-color: ${colors.primary};
    border: 1px solid ${colors.primary};
    color: #fff;
    padding: 0.5rem 1.5rem;
    border-radius: 0.2rem;
    font-size: 1rem;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    margin-top: 1rem;
    &:hover {
      color: ${colors.primary};
      background-color: #fff;
    }
  }
`;

const Loader = styled.div`
  padding: 7rem 1rem;
  text-align: center;
`;

export default EditFaq;
